<template>
    <div>
        <div v-if="name" class="mb-1 text-xxs text-secondary">{{ name }}</div>
        <Table striped borderless>
            <slot></slot>
        </Table>
    </div>
</template>

<script>
    import Table from '../Table';

    export default {
        name: 'Sheet',
        components: {
            Table
        },
        props: {
            name: String
        },
        data() {
            return {
                rows: []
            }
        },
        created() {
            this.rows = this.$children;
        }
    }
</script>
